import React from "react";

import {
  faArrowUpRightFromSquare,
  faCircleInfo,
} from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

export const WEB_SEARCH_TOOL_INFO = "Powered by Parallel";
export const WEB_SEARCH_DATA_RESIDENCY_INFO =
  "Web search data is always processed in the US, regardless of your workspace region";
export const WEB_SEARCH_DOCS_LINK =
  "https://docs.taktile.com/agents/agents-builder#built-in-tools";

export const WebSearchInfoTooltip: React.FC = () => (
  <Tooltip
    body={
      <>
        {WEB_SEARCH_TOOL_INFO}. {WEB_SEARCH_DATA_RESIDENCY_INFO}.{" "}
        <button
          className="inline-flex items-center gap-1 underline"
          data-loc="web-search-info-tooltip-read-more"
          type="button"
          onClick={() => window.open(WEB_SEARCH_DOCS_LINK, "_blank")}
        >
          Read more
          <Icon icon={faArrowUpRightFromSquare} size="2xs" variant="inverted" />
        </button>
      </>
    }
    dataLoc="web-search-info-tooltip"
    placement="top"
  >
    <span
      className="inline-flex text-gray-500"
      data-loc="web-search-info-tooltip-icon"
    >
      <Icon icon={faCircleInfo} size="sm" />
    </span>
  </Tooltip>
);
